import {
  type CanvasEventTarget,
  canvasEventTargets,
} from '@canvas/input-types/event-targets';

export * from '@canvas/input-types/event-targets';

export const isEventTarget = (input: any): input is CanvasEventTarget => {
  return canvasEventTargets.includes(input);
};
